'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const ShiftCoverageTrendChart = dynamic(() => import('./ShiftCoverageTrendChart'), { ssr: false });
const PayrollLiabilityChart = dynamic(() => import('./PayrollLiabilityChart'), { ssr: false });

interface Props {
  payrollRecords: any[];
  scheduledShifts: any[];
}

export default function ChartsRow({ payrollRecords, scheduledShifts }: Props) {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
      <ShiftCoverageTrendChart scheduledShifts={scheduledShifts} />
      <PayrollLiabilityChart payrollRecords={payrollRecords} />
    </div>
  );
}